import { render, staticRenderFns } from "./PowerBanner.vue?vue&type=template&id=846bea6c&scoped=true&"
import script from "./PowerBanner.vue?vue&type=script&lang=js&"
export * from "./PowerBanner.vue?vue&type=script&lang=js&"
import style0 from "./PowerBanner.vue?vue&type=style&index=0&id=846bea6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846bea6c",
  null
  
)

export default component.exports